// docs/175 — who writes a World: the profile kept on `world.storyteller` (fk-schema `storyteller`).
// Gritty and After Dark are uncensored, written by Grok: gritty may be dark, violent and gory;
// after dark is steered toward mature romance. Only a keeper whose account allows uncensored
// lobbies may choose one, and everyone sees when a World is one.
export const STORYTELLER_STANDARD = 0;
export const STORYTELLER_GRITTY = 1;
export const STORYTELLER_AFTER_DARK = 2;

export const STORYTELLERS = [
  { value: STORYTELLER_STANDARD, label: 'Standard', about: '' },
  { value: STORYTELLER_GRITTY, label: 'Gritty', about: 'uncensored: dark, violent and gory' },
  { value: STORYTELLER_AFTER_DARK, label: 'After Dark', about: 'uncensored: steered toward mature romance' },
];

export const isUncensored = (w: { storyteller: number } | undefined) => !!w && w.storyteller !== STORYTELLER_STANDARD;
/** The badge an uncensored World carries in the lists and the lobby, or undefined. */
export const uncensoredLabel = (w: { storyteller: number } | undefined) => (isUncensored(w) ? STORYTELLERS.find((s) => s.value === w!.storyteller)?.label.toLowerCase() ?? 'uncensored' : undefined);
